module.exports = __webpack_public_path__ + "img/icon5.b1fd24e9.png";